import React from "react";
import ModelDataValueUpdateDetailsBase from "./updateModelDataValueBase";
import { ValueChange } from "./baseDetails";
import { dateWithFormat } from "../../tools";

export default function modelDataValueUpdateDateDetails({ row }) {
    const oldValue = row.old_value ? dateWithFormat(row.old_value) : null;
    const newValue = row.new_value ? dateWithFormat(row.new_value) : null;

    return (
        <ModelDataValueUpdateDetailsBase row={row}>
            <ValueChange oldValue={oldValue} newValue={newValue} />
        </ModelDataValueUpdateDetailsBase>
    );
}
